export const sportsLinkMobileWeb: string = 'https://lvbet.com/sports/{lang}/';
export const sportsLinkWeb: string = 'https://lvbet.com/sports/{lang}/';

export const tgSportsLinkMobileWeb: string = 'https://lvbettg.com/sports/{lang}/';
export const tgSportsLinkWeb: string = 'https://lvbettg.com/sports/{lang}/';
